import {useState} from 'react'
import {TemporaryToggle} from '../../UserManagement/UserManagementStyle'
import PropTypes from 'prop-types'
import {
  UserFeedbackNote,
  UserFeedbackSubTitle,
  CustomInfoIcon,
  StyledAlert,
  StyledAlertTitle,
  UserFeedbackContainer
} from './UserFeedbackStyle'
import {useUserFeedback} from '../../../store/hooks/userFeedback'
import CreateClosePopup from '../../../components/Dashboard/UserFeedback/CreateClosePopup'
import {Box, Typography} from '@mui/material'

const UserFeedbackComponent = ({selectedFeedback, setSelectedFeedback, setCloseExistingEventFlag}) => {
  const {eventDetails} = useUserFeedback()
  const [isActiveEventDialogOpen, setIsActiveEventDialogOpen] = useState(false)
  const activeEventWarningConfig = {
    title: 'Active Event Detected!',
    message: (
      <>
        There’s an open event titled <b>{eventDetails?.EVENT_NAME || '“Conference XYZ”'}</b> that hasn’t been manually
        closed. If you turn off User Feedback mode, this event will close automatically.
        <br />
        <br />
        Are you sure you want to continue?
      </>
    ),
    confirmButtonText: 'Confirm',
    confirmButtonColor: 'primary',
    showWarningIcon: true,
    onConfirm: async () => {
      setIsActiveEventDialogOpen(false)
      setCloseExistingEventFlag(true)
      const newFeedbackValue = [1 - selectedFeedback[0]]
      setSelectedFeedback(newFeedbackValue)
    }
  }
  const setSelectedFeedbackFunction = () => {
    if (eventDetails?.IS_ACTIVE) {
      setIsActiveEventDialogOpen(true)
      return
    }
    const newFeedbackValue = [1 - selectedFeedback[0]]
    setSelectedFeedback(newFeedbackValue)
  }
  const [alertOpen, setAlertOpen] = useState(true)

  const handleAlertClose = () => {
    setAlertOpen(false)
  }

  return (
    <UserFeedbackContainer tabIndex={0} aria-label='user feedback'>
      <CreateClosePopup
        onClose={() => setIsActiveEventDialogOpen(false)}
        open={isActiveEventDialogOpen}
        {...activeEventWarningConfig}
      />
      <Box gap={10} alignItems='center' display='flex'>
        <Box maxWidth='45%'>
          <UserFeedbackSubTitle>
            This feature lets you capture user actions and feedback within the application for later analysis in Adobe
            Analytics. You can use it during free exploration sessions, usability testing sessions, guerrilla tests, or
            other feedback capturing sessions.
          </UserFeedbackSubTitle>
        </Box>
        <Box width='fit-content' display='flex' alignItems='center' gap={1}>
          <Box mr={1}>
            <Typography>Off</Typography>
          </Box>
          <TemporaryToggle
            id='feedback-toggle-switch'
            tabIndex={0}
            checked={selectedFeedback?.length > 0 ? selectedFeedback[0] : false}
            onChange={setSelectedFeedbackFunction}
            aria-label='Feedback Toggle'
          />
          <Typography>On</Typography>
        </Box>
      </Box>
      {alertOpen && (
        <StyledAlert severity='info' onClose={handleAlertClose} icon={<CustomInfoIcon />}>
          <StyledAlertTitle>
            Before collecting user feedback, ensure all items under the Filter categories, POIs, and other sections are
            labeled correctly.
          </StyledAlertTitle>
        </StyledAlert>
      )}
      <UserFeedbackNote>
        <b>Note: </b>When enabled, essential tools will appear in the top right of your dashboard. You&apos;ll first be
        prompted to create an event by entering a unique event name, followed by participant details.
      </UserFeedbackNote>
    </UserFeedbackContainer>
  )
}

UserFeedbackComponent.propTypes = {
  setSelectedFeedback: PropTypes.func.isRequired,
  selectedFeedback: PropTypes.bool.isRequired,
  setCloseExistingEventFlag: PropTypes.func.isRequired
}

export default UserFeedbackComponent
